"use strict";
/*
 * Created on 24. 6. 2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");

var immutable_1 = require("immutable");

var utils_1 = require("../../core/utils");
/**
 * @author Radek Beran
 */


var KpiConversions =
/*#__PURE__*/
function () {
  function KpiConversions() {
    _classCallCheck(this, KpiConversions);
  }

  _createClass(KpiConversions, null, [{
    key: "kpiToDoc",
    value: function kpiToDoc(source, conversions) {
      return source.map(function (a) {
        return a.toNumber();
      }).toObject();
    }
  }, {
    key: "kpiToObj",
    value: function kpiToObj(source, conversions) {
      var map = immutable_1.Map();
      Object.keys(source).forEach(function (key) {
        if (!utils_1.Utils.isValueMissing(source[key])) {
          map = map.set(key, big_decimal_1.bigdecimal(source[key]));
        }
      });
      return map.size ? map : null;
    }
  }]);

  return KpiConversions;
}();

exports.KpiConversions = KpiConversions;